import React from "react";
import { RatingOverviewContext } from "../../context/ratingOverviewContext";
import IRatingOverviewSearch from "../../interface/iRatingOverviewSearch";
import InputDate from "../../../../components/inputs/date/inputDate";

const SearchFromDate = (): React.JSX.Element => {
  const {
    ratingOverviewSearch,
    setRatingOverviewSearch,
  }: {
    ratingOverviewSearch: IRatingOverviewSearch;
    setRatingOverviewSearch: React.Dispatch<
      React.SetStateAction<IRatingOverviewSearch>
    >;
  } = React.useContext(RatingOverviewContext);

  const handleChange = (date: any): void =>
    setRatingOverviewSearch((prevState: any) => ({
      ...prevState,
      fromDate: date,
    }));

  return (
    <InputDate
      disabled={false}
      label="Start"
      error
      required
      date={ratingOverviewSearch.fromDate}
      setDate={handleChange}
    />
  );
};

export default SearchFromDate;
